export function withTimedCache(fn, options) {
    let cache;
    let cacheTime = 0;
    let hasCache = false;

    const wrapped = () => {
        const now = Date.now();

        if (hasCache && now - cacheTime < options.ttl) {
            return cache;
        }

        cache = fn();
        cacheTime = now;
        hasCache = true;

        return cache;
    };

    wrapped.clear = () => {
        cache = undefined;
        cacheTime = 0;
        hasCache = false;
    };

    return wrapped;
}
